import React from "react";

import { Detach } from "../../svg/svgImageList";
import Tooltip, { ComponentWithTooltipProps } from "../../tooltip/Tooltip";
import Button from "../../button/Button";
import { videoPlayerService } from "../../../services/video-player/VideoPlayerService";

const elementId = "video-detach-control";

export default function DetachVideo({ tooltipTextKey }: ComponentWithTooltipProps) {
  const { isPictureInPicture, detachVideo, cancelDetachVideo } = videoPlayerService;

  if (!document["pictureInPictureEnabled"]) return null;

  return (
    <Tooltip id={elementId} title={tooltipTextKey}>
      <Button
        id={elementId}
        onClick={isPictureInPicture ? cancelDetachVideo : detachVideo}
        icon={{
          svg: Detach,
          className: `video-control-item detach ${isPictureInPicture ? " active" : ""}`,
        }}
      />
    </Tooltip>
  );
}
